// src/app/app-routing.config.ts
import {Routes} from '@angular/router';

export const oakvilleRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/peelhalton/oakville/oakville.module').then(m => m.OakvilleModule)
  },
  {
    path: 'fulldetails',
    loadChildren: () => import('./features/peelhalton/oakville/oakville.module').then(m => m.OakvilleModule)
  }
];

export const muskokaRoutes: Routes = [

  // Toronto module (lazy loaded)
  {
    path: 'search/toronto',
    loadChildren: () => import('./features/toronto/toronto.module').then(m => m.TorontoModule)
  },

  // PeelHalton cities (lazy loaded)
  {
    path: 'search/oakville',
    loadChildren: () => import('./features/peelhalton/oakville/oakville.module').then(m => m.OakvilleModule)
  },
  {
    path: 'search/burlington',
    loadChildren: () => import('./features/peelhalton/burlington/burlington.module').then(m => m.BurlingtonModule)
  },
  {
    path: 'search/mississauga',
    loadChildren: () => import('./features/peelhalton/mississauga/mississauga.module').then(m => m.MississaugaModule)
  },

  // Muskoka module (lazy loaded)
  {
    path: 'search/sold',
    loadChildren: () => import('./features/muskoka/sold-properties/sold.module').then(m => m.SoldModule),
    data: {debug: 'MuskokaDashboardComponent'}

  },
  {
    path: 'search/rentals',
    loadChildren: () => import('./features/muskoka/rentals/rental.module').then(m => m.RentalModule),
    data: {debug: 'MuskokaDashboardComponent'}

  },
  {
    path: 'search',
    loadChildren: () => import('./features/muskoka/muskoka.module').then(m => m.MuskokaModule),
    data: {debug: 'MuskokaDashboardComponent'}

  },

  // Root level fulldetails routes (handled by PeelHalton module)
  {
    path: 'fulldetails',
    loadChildren: () => import('./features/muskoka/muskoka.module').then(m => m.MuskokaModule)
  },

  // Default route (Muskoka dashboard)
  {path: '', loadChildren: () => import('./features/muskoka/muskoka.module').then(m => m.MuskokaModule)},


  // Catch-all route
  {path: '**', redirectTo: ''}
];
